import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable, BehaviorSubject } from "rxjs";
import {
  ActivityRoles,
  ActivityCity,
  ActivityClinic,
  ActivityDoctor,
  ActivityRequest,
  ActivitiesData,
  ActivitySearch,
  ActivityResponse,
  ActivityLevelApproval,
} from "../models/activity-model";
import { map } from "rxjs/operators";
import { Speciality, CitiesList, ActivityDto } from "../models/common-model";

@Injectable({
  providedIn: "root",
})
export class ActivityService {
  activities = new BehaviorSubject<ActivityResponse>(null);

  activityObj = new BehaviorSubject<ActivitiesData>(null);

  activitySearch = <ActivitySearch>{};

  rowCount: number = 50;
  pageNo: number = 0;

  loading: boolean = false;

  specialities = new BehaviorSubject<Speciality[]>([]);
  cities = new BehaviorSubject<CitiesList[]>([]);
  clinics = new BehaviorSubject<ActivityClinic[]>([]);
  doctors = new BehaviorSubject<ActivityDoctor[]>([]);

  constructor(private http: HttpClient) {}

  addActivity(payload: ActivityRequest) {
    return this.http.post<any>(
      environment.apiUrl + "ActivityManagment/AddActivity",
      payload
    );
  }

  updateActivity(payload: ActivityRequest) {
    return this.http.post<any>(
      environment.apiUrl + "ActivityManagment/UpdateActivity",
      payload
    );
  }

  updateActivityStatus(payload: any) {
    return this.http.post(
      `${environment.apiUrl}ActivityManagment/UpdateActivityActiveDeactiveRequest`,
      payload
    );
  }

  updateMarkAsCompleteStatus(payload: any) {
    return this.http.post(
      `${environment.apiUrl}ActivityManagment/UpdateActivityMarkAsComplete`,
      payload
    );
  }

  getAllActivities() {
    this.activitySearch.rowsCount = this.rowCount;
    this.activitySearch.pageNo = this.pageNo;
    this.loading = true;
    this.http
      .post(
        environment.apiUrl + "ActivityManagment/FetchAllActivities",
        this.activitySearch
      )
      .pipe(
        map((resp: any) => {
          debugger;
          if (resp && resp.response) {
            return resp.response;
          }
          return [];
        })
      )
      .subscribe(
        (res) => {
          this.loading = false;
          this.activities.next(res);
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  getAllActivityRoles = (): Observable<ActivityRoles[]> => {
    return this.http
      .get<ActivityRoles[]>(`${environment.apiUrl}LookUp/FetchAllActivityRoles`)
      .pipe(
        map((resp: any) => {
          if (resp && resp.response && resp.response.length > 0)
            return resp.response;
          return [];
        })
      );
  };

  getAllActivityCities = (): Observable<ActivityCity[]> => {
    return this.http
      .get<any>(`${environment.apiUrl}AskApollo/FetchCities/1/2`)
      .pipe(
        map((resp: any) => {
          if (resp && resp.response && Array.isArray(resp.response)) {
            return resp.response;
          }
          return [];
        })
      );
  };

  getAllActivityCities1 = (): Observable<ActivityCity[]> => {
    return this.http
      .get<ActivityCity[]>(`${environment.apiUrl}ask/FetchCities`)
      .pipe(
        map((resp: any) => {
          if (resp && resp.response && resp.response.length > 0)
            return resp.response;
          return [];
        })
      );
  };

  getAllActivityClinic = (): Observable<ActivityClinic[]> => {
    return this.http
      .get<ActivityClinic[]>(`${environment.apiUrl}LookUp/FetchAllClinics`)
      .pipe(
        map((resp: any) => {
          if (resp && resp.response && resp.response.length > 0)
            return resp.response;
          return [];
        })
      );
  };

  getAllActivityDoctors = (): Observable<ActivityDoctor[]> => {
    return this.http
      .get<ActivityDoctor[]>(`${environment.apiUrl}LookUp/FetchAllDoctors`)
      .pipe(
        map((resp: any) => {
          if (resp && resp.response && resp.response.length > 0)
            return resp.response;
          return [];
        })
      );
  };

  updateActivityApprovalStatus(payload: any): Observable<any> {
    return this.http.put(
      `${environment.apiUrl}ActivityManagment/UpdateActivityLevelApproval`,
      payload
    );
  }

  getActivityLeadLog = (
    activityId: number
  ): Observable<ActivityLevelApproval[]> => {
    return this.http
      .get<ActivityLevelApproval[]>(
        `${environment.apiUrl}ActivityManagment/FetchActivityApprovalLogs/${activityId}`
      )
      .pipe(
        map((levels: any) => {
          return levels.response;
        })
      );
  };

  getAllCRMDoctors(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "ActivityManagment/FetchAllCRMDoctorsOnFilter/",
      payload
    );
  }
  addCRMDoctorInfo(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "ActivityManagment/AddCRMDoctorInfo",
      payload
    );
  }

  updateCRMDoctorInfo(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "ActivityManagment/UpdateCRMDoctorInfo",
      payload
    );
  }
  activateDeactivateCRMDoctor(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "ActivityManagment/ActivateDeactivateCRMDoctor",
      payload
    );
  }

  activityReschedule = (payload: any): Observable<any> => {
    return this.http.post(
      `${environment.apiUrl}ActivityManagment/RescheduleActivity`,
      payload
    );
  };

  downloadActivityLeadSampleTemplate() {
    return this.http.get(
      `${environment.apiUrl}ActivityManagment/DownloadSampleActivityLeadUploadFile`
    );
  }
  uploadActivityLeadFile(activityId, FileData: any) {
    return this.http.post(
      environment.apiUrl +
        "ActivityManagment/UploadBulkActivityLead/" +
        activityId,
      FileData,
      { reportProgress: true, observe: "events" }
    );
  }

  getUsersByRoleId = (roleId: number): Observable<any> => {
    return this.http.get(
      `${environment.apiUrl}UserManagement/GetUsersOnRoleId/${roleId}`
    );
  };

  activityConfigAdd = (payload: any): Observable<any> => {
    return this.http.post(
      `${environment.apiUrl}ActivityManagment/AddActivitySettingConfig`,
      payload
    );
  };

  deleteActivityConfig = (levelId: number): Observable<any> => {
  return this.http.delete(
    `${environment.apiUrl}ActivityManagment/DeleteApprovalConfig/${levelId}`
  );
};
  activityConfigGet = (): Observable<any> => {
    return this.http.get(
      `${environment.apiUrl}ActivityManagment/GetActicityConfigList`
    );
  };
  getApprovedActivities(): Observable<ActivityDto[]> {
    return this.http.get<ActivityDto[]>(
      `${environment.apiUrl}ActivityManagment/GetApprovedActivityList`
    );
  }
  getAllFeatures = (): Observable<any> => {
    return this.http.get(
      `${environment.apiUrl}UserManagement/GetAllFeatures`
    );
  };
}
